import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { interval, Subscription } from 'rxjs';
import { ESsystemUserProfile, ESystemOrganizacion, ESystemAccess } from 'src/app/enum/EAccess';
import { CognitoService, IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { CredencialesService } from 'src/app/shared/services/credenciales.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { AsincronoService } from 'src/app/shared/services/asincrono.service';

export interface SubMenuAction {
  label: string;
  url: string;
}

export interface SubMenuOption {
  label: string;
  icon?: string;
  url?: string;
  actions?: SubMenuAction[];
  hasAccess?: boolean;
  group?: SubMenuOption[];
}

const SUBMENU_VALUES = {
  FLUJOS_CREDITO: "flujosCredito",
  SERVICIOS: "servicios",
  ADMIN_CARTERA: "adminCartera",
  CESION: "cesion",
  FIRMAS: "firmas",
  OFERTAS: "ofertas",
  MOROSOS: "morosos",
  GRUPOS: "grupos",
  AJUSTES: "ajustes",
  USER_INFO: "usuario",
  MONITOREO_SERVICIOS: "monitoreoServicios",
}

const SUBMENU_SERVICIOS: SubMenuOption[] = [
  { label: "Consolidado", icon: "gi gi-credit_card", url: undefined,
    group: [
      { label: "Reporte Consolidado", icon: "gi gi-credit_card", url: "reporte-consolidado/consultar" },
    ]
  },

  { label: "Comerciales", icon: "gi gi-notes_2", url: undefined,
    group: [
      { label: "Reporte Básico", icon: "gi gi-notes_2", url: undefined,
        actions: [ { label: "Consultar", url: "reportes/reporte-basico/consultar"}, { label: "Buscar", url: "reportes/reporte-basico/buscar" } ] },
      /*{ label: "Malla Societaria", icon: "fa fa-sitemap", url: "",
        actions: [ { label: "Consultar", url: "reporte-malla-societaria/consultar"}, { label: "Buscar", url: "reporte-malla-societaria/buscar" } ] },
      { label: "Malla De quien es", icon: "fa fa-user-circle-o", url: "reportes/de-quien-es" },*/
      { label: "Vehículos", icon: "fa fa-car", url: "",
        actions: [ { label: "Consultar", url: "reportes/vehiculos/consultar"}, { label: "Buscar", url: "reportes/vehiculos/buscar" } ] },
      { label: "Bienes Raíces", icon: "fa fa-home", url: "",
        actions: [ { label: "Consultar", url: "reportes/bienes-raices/consultar"}, { label: "Buscar", url: "reportes/bienes-raices/buscar" } ] },
      { label: "Boletín Concursal", icon: "fa fa-newspaper-o", url: "",
        actions: [ { label: "Consultar", url: "reportes/boletin-concursal/consultar"}, { label: "Buscar", url: "reportes/boletin-concursal/buscar" } ] },
      { label: "Mercado Público", icon: "fa fa-shopping-cart", url: "",
        actions: [ { label: "Licitaciones", url: "reportes/reporte-mercado-publico/licitaciones"}, { label: "Órdenes de Compra", url: "reportes/reporte-mercado-publico/ordenes-compra" } ] },
      { label: "Deuda Sbif Leasing", icon: "fa fa-credit-card", url: "",
        actions: [ { label: "Consultar", url: "reportes/deuda-sbif-leasing/consultar"}, { label: "Buscar", url: "reportes/deuda-sbif-leasing/buscar" } ] }, 
    ]
  },

  { label: "Malla Societaria", icon: "fa fa-sitemap", url: undefined, group: []},

  { label: "Financieros", icon: "fa fa-bar-chart", url: undefined,
    group: [
      { label: "Reporte Financiero", icon: "fa fa-bar-chart", url: "reportes/reporte-financiero" },
      { label: "Comparativo Estados Financieros", icon: "fa fa-files-o", url: "reportes/comparativo-balances/consultar" },
      { label: "Libro Compra Venta", icon: "fa fa-book", url: "",
        actions: [ { label: "Consultar", url: "reportes/compra-venta/consultar"}, { label: "Buscar", url: "reportes/compra-venta/buscar" } ] },
      { label: "Reporte Tesorería", icon: "fa fa-university", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-tesoreria/consultar"}, { label: "Buscar", url: "reportes/reporte-tesoreria/buscar" } ] },
      { label: "Solicitudes", icon: "fa fa-envelope", url: "solicitudes/consultar" },
      { label: "Solicitud de Crédito", icon: "gi gi-credit_card", url: "solicitud-credito/consultar" },
      { label: "Panel de Riesgo", icon: "fa fa-exclamation-triangle", url: "reportes/panelriesgo" },
    ]
  },

  { label: "Legal y compliance", icon: "fa fa-balance-scale", url: undefined,
    group: [
      { label: "Informe Judicial", icon: "fa fa-balance-scale", url: "",
        actions: [ { label: "Consultar", url: "reportes/judicial/consultar"}, { label: "Buscar", url: "reportes/judicial/buscar" } ] },
      { label: "Empresa en un día", icon: "fa fa-industry", url: "",
        actions: [ { label: "Certificados", url: "reportes/empresa-en-un-dia/certificados"}, { label: "Actuaciones", url: "reportes/empresa-en-un-dia/actuaciones" } ] },
      { label: "Reporte Compliance", icon: "fa fa-th-list", url: "",
        actions: [ { label: "Consultar", url: "reportes/regcheq/consultar"}, { label: "Buscar", url: "reportes/regcheq/buscar" } ] },
    ]
  },
  { label: "Dirección del trabajo", icon: "fa fa-building", url: undefined,
    group: [
        { label: "Reporte Mora Presunta", icon: "fa fa-exclamation-triangle", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-mora-presunta/consultar"}, { label: "Buscar", url: "reportes/reporte-mora-presunta/buscar" } ] },
        { label: "Reporte F301", icon: "fa fa-check-square", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-f301/consultar"}, { label: "Buscar", url: "reportes/reporte-f301/buscar" } ] },
        { label: "Reporte Multas", icon: "fa fa-ticket", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-multas/consultar"}, { label: "Buscar", url: "reportes/reporte-multas/buscar" } ] },
    ]
  },
  { label: "Contribuciones", icon: "fa fa-usd", url: undefined,
    group: [
      { label: "Reporte Avalúo Fiscal", icon: "fa fa-home", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-avaluo-fiscal/consultar"}, { label: "Buscar", url: "reportes/reporte-avaluo-fiscal/buscar" } ] },
      { label: "Reporte Contribuciones", icon: "fa fa-money", url: "",
        actions: [ { label: "Consultar", url: "reportes/reporte-contribuciones/consultar"}, { label: "Buscar", url: "reportes/reporte-contribuciones/buscar" } ] },
    ]
  },
  { label: "TAG", icon: "fa fa-car", url: undefined,
    actions: [
        { label: "Consultar", url: "reportes/tag/consultar"},
        { label: "Buscar", url: "reportes/tag/buscar" }
    ],
  },
]

const SUBMENU_MOROSOS: SubMenuOption[] = [
  { label: "Cobranza Online", icon: "fa fa-legal", url: "",
    actions: [ { label: "Publicar", url: "cobranza-online/publicar"}, { label: "Buscar", url: "cobranza-online/buscar" } ] },
  { label: "Modulo Cobranza", icon: "fa fa-bar-chart", url: "modulo-cobranza" },
]

const SUBMENU_USUARIOS: SubMenuOption[] = [
  { label: "Administración de Usuarios", url: 'usuarios-grupos/usuarios/listar' },
  { label: "Administracion de Grupos", url: 'usuarios-grupos/grupos/listar' },
  { label: "Organizaciones", url: 'usuarios-grupos/organizacion/listar' },
]

const SUBMENU_AJUSTES: SubMenuOption[] = [
  { label: "Campos Personalizados", url: 'ajustes/campos-personalizados' },
  { label: "Administrar Sujetos de Crédito", url: 'ajustes/admin-sujeto-credito' },
  { label: "Administración de Credenciales", url: undefined, 
    actions: [ { label: "Organización", url: "ajustes/credenciales/organizacion"}, 
                { label: "Usuarios", url: "ajustes/credenciales/usuario" } ] },
]

const SUBMENU_FLUJOS: SubMenuOption[] = [
  { label: "Flujo de crédito", url: 'flujo-credito/consultar' },
  { label: "Flujo de crédito light", url: 'flujo-credito-light/seleccion-modelo' },
  { label: "Firma documentos", url: 'firma-documentos' },
]

@Component({
  selector: 'app-mat-side-menu',
  templateUrl: './mat-side-menu.component.html',
  styleUrls: ['./mat-side-menu.component.scss']
})
export class MatSideMenuComponent {
  public username = '';
  public organization = '';
  public userInfo: IUserInfoCognito | null = null;
  public hasOrganizationSelected = false;
  public hasManyOrganization = false;
  public isUser: boolean = false;
  public organizacionValid: boolean = false;
  private access: string = ESsystemUserProfile.USERUNIQUE;
  private accessOrg: string[] = ESystemOrganizacion.ORGANIZACION_ACCESS;
  private organizacionValidaFlujoCredito: string[] = ['DESARROLLO', 'salfa300008', 'SOPORTE'];
  private intervalSubscription!: Subscription;
  public validateAccess: string[] = ['Malla Societaria'];

  @ViewChild('requestAccessPanel') expansionPanel: MatExpansionPanel | null = null;
  @ViewChild('sidenavInner') sidenav: MatSidenav | null = null;
  opened = false;
  selectedSubMenu = "";
  subMenuValues = SUBMENU_VALUES;
  currentSubMenuOptions: SubMenuOption[] = [];

  subMenuServicios: SubMenuOption[] = SUBMENU_SERVICIOS;
  subMenuGrupos: SubMenuOption[] = SUBMENU_USUARIOS;
  subMenuAjustes: SubMenuOption[] = SUBMENU_AJUSTES;
  subMenuMorosos: SubMenuOption[] = SUBMENU_MOROSOS;
  subMenuFlujos: SubMenuOption[] = SUBMENU_FLUJOS;

  hasServiceErrors$ = this.asincronoService.hasServiceErrors$;
  
  constructor(
    private _cognitoService: CognitoService,
    private _sessionService: SessionService,
    private router: Router,
    public authenticator: AuthenticatorService,
    private credencialesService: CredencialesService,
    private utilsService: UtilsService,
    private asincronoService: AsincronoService,
  ) {}

  setSelected(subMenu: string) {
    this.selectedSubMenu = subMenu;
    this.sidenav?.close();
  }

  openNav(subMenu: string) {
    if(subMenu == this.selectedSubMenu) {
      if(this.sidenav?.opened) {
        this.selectedSubMenu = "";
        this.sidenav?.close();
      } else {
        this.sidenav?.open();
      }
      return
    }
    
    this.sidenav?.open();
    this.selectedSubMenu = subMenu;

    if(subMenu == this.subMenuValues.SERVICIOS) {
      this.currentSubMenuOptions = this.subMenuServicios;
    } else if (subMenu == this.subMenuValues.GRUPOS) {
      this.currentSubMenuOptions = this.subMenuGrupos;
    } else if (subMenu == this.subMenuValues.AJUSTES) {
      this.currentSubMenuOptions = this.subMenuAjustes;
    } else if (subMenu == this.subMenuValues.MOROSOS) {
      this.currentSubMenuOptions = this.subMenuMorosos;
    } else if (subMenu == this.subMenuValues.FLUJOS_CREDITO) {
        this.currentSubMenuOptions = this.subMenuFlujos;
    } else {
      this.currentSubMenuOptions = [];
    }
  }
  resetComponent(): void {
    this.userInfo = null;
    this.hasManyOrganization = false;
    this.isUser = false;
    this.organizacionValid = false;
    this.organization = '';
    this.hasOrganizationSelected = false;
  }

  getOrganizationSequence(): void {
      this.resetComponent();
  
      this.userInfo = this._sessionService.getUserInfo();
      this.organization = this._sessionService.getOrganization();
      this.hasManyOrganization = this._sessionService.hasManyOrganizations();
      
      if (this.organization && this.organization !== '') {
        this.hasOrganizationSelected = true;
      } else {
        this.hasOrganizationSelected = false;
      }
  
      if (this.userInfo && this.userInfo.email.includes(this.access) && this.accessOrg.includes(this._sessionService.getOrganization())) {
        this.isUser = true;
      } else {
        this.isUser = false;
      }
  
      if (this.accessOrg[0] === this._sessionService.getOrganization()) {      
        this.organizacionValid = true;
      } else {
        this.organizacionValid = false
      }

      this.checkOptionsAccess();
    }
  
    handleStorageEvent = (event: any) => {
      this.getOrganizationSequence();
    }
  
    ngOnInit(): void {
      if(this.authenticator.authStatus === 'authenticated') {
        this.getOrganizationSequence();  
        window.addEventListener('storage', this.handleStorageEvent);

        this.validateMallaSubMenu();
      }
    }
  
    startInterval() {
      this.intervalSubscription = interval(1000).subscribe(() => {
        this.getOrganizationSequence();
      });
    }
  
    public swithOrganization() {
      this._sessionService.removeSelectedOrganization();
      this.router.navigate(['/organizacion']);
    }

    /*public goToMfaConfiguracion() {
      this.router.navigate(['/mfa-configuracion']);
    }*/
  
    public logout() {
      this._cognitoService.logout();
    }
  
    public validaOrganizacionFlujoCredito(): boolean {
      return this.organizacionValidaFlujoCredito.includes(this.organization); 
    }
  
    ngOnDestroy(): void {
      if(this.handleStorageEvent){
        window.removeEventListener('storage', this.handleStorageEvent);
      }
    }

    checkOptionsAccess() {
      this.subMenuServicios = this.subMenuServicios.map((servicio: SubMenuOption) => {

        if(servicio.group) {
          let servicioMod = servicio;
          servicioMod.hasAccess = true;
          servicioMod.group = servicio.group.map((servicioGrupo: SubMenuOption) => {
            if(servicioGrupo.label == "Solicitud de Crédito") {
              return { ...servicioGrupo, hasAccess: this.validaOrganizacionFlujoCredito()}
            } else if (servicioGrupo.label == "Panel de Riesgo"){
              return { ...servicioGrupo, hasAccess: this.organization === 'DESARROLLO' || this.organization === 'SOPORTE'}
            } else {
              return { ...servicioGrupo, hasAccess: true}
            }
          })
          return servicioMod;
        }

        // Borrar
        if(servicio.label == "Solicitud de Crédito") {
          return { ...servicio, hasAccess: this.validaOrganizacionFlujoCredito()}
        } else if (servicio.label == "Panel de Riesgo"){
          return { ...servicio, hasAccess: this.organization === 'DESARROLLO' || this.organization === 'SOPORTE'}
        } else {
          return { ...servicio, hasAccess: true}
        }
      })

      this.subMenuGrupos = this.subMenuGrupos.map((option: SubMenuOption) => {
        if(option.label == "Organizaciones") {
          return { ...option, hasAccess: this.isUser}
        } else {
          return { ...option, hasAccess: true}
        }
      })

      this.subMenuAjustes = this.subMenuAjustes.map((option: SubMenuOption) => {
        return { ...option, hasAccess: true}
      })

      this.subMenuMorosos = this.subMenuMorosos.map((option: SubMenuOption) => {
        return { ...option, hasAccess: true}
      })

      this.subMenuFlujos = this.subMenuFlujos.map((option: SubMenuOption) => {
        return { ...option, hasAccess: true}
      })

    }

  validateMallaSubMenu() {
    if(this.hasOrganizationSelected == true) {
      const index = this.subMenuServicios.findIndex(e => e.label === 'Malla Societaria');
      if(index >= 0) {
        this.credencialesService.listarSecretosOrgyUsuarios().subscribe(
          (data: any) => {
            const tablaServicios: any[] = data?.OrgConfiguration?.services?.services || [];
            if((tablaServicios.length > 0)){
              this.subMenuServicios[index].group = [];
              const servicioMallaTransunion = tablaServicios.find(e => e.name === 'MALLA_SOCIETARIA_TRANSUNION');
              const servicioMallaDeQuienes = tablaServicios.find(e => e.name === 'MALLA_SOCIETARIA_DEQUIENES');
              if(this.utilsService.validacionEstadoServicio(servicioMallaTransunion) == true) {
                this.subMenuServicios[index].group?.push(
                  { label: "Malla Societaria", 
                    icon: "", 
                    url: "",
                    hasAccess: true, 
                    actions: [
                      {label: "Consultar", url: "reportes/malla-societaria/consultar"},
                      {label: "Buscar", url: "reportes/malla-societaria/buscar"}
                    ]
                  }
                );
              }
              if(this.utilsService.validacionEstadoServicio(servicioMallaDeQuienes) == true) {
                this.subMenuServicios[index].group?.push(
                  { 
                    label: "Malla Relacional", 
                    icon: "", 
                    url: "reportes/malla-relacional",
                    hasAccess: true
                  }
                );
              }
            }
          },
          ({ error }) => {
            console.error(error.message || 'Ha ocurrido un error al obtener el listado de servicios configurados.')
        });
      }
    }
  }

  validateByLabel(label: string): boolean {
    const safeLabel = label || '';

    if (this.validateAccess.includes(safeLabel)) {
      if (safeLabel === 'Malla Societaria') {
        const accessMalla = [
          ESystemAccess.REPORTE_MALLA_SOCIETARIA,
          ESystemAccess.REPORTE_MALLA_SOCIETARIA_BUSCAR
        ];
        const userAccess = this._sessionService.getUserAccess();
        return accessMalla.some(a => userAccess.includes(a));
      }
      return true;
    }

    // Si no está en validateAccess, mantener funcionamiento actual
    return true;
  }

  goToRequestAccess() {
    if(this.expansionPanel) {
      this.expansionPanel.close();
    }
    this.router.navigate(['/request-access']);
  }
}
